import React, { Component } from 'react';
import CloudPanel from '@components/CloudPanel/CloudPanel';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';

class NotFound extends Component {
  render() {
    const isMobile = this.props.pageWidth < 992;
    let className = '';
    if (isMobile) {
      className = 'pt-5 mt-5 mb-5';
    } else {
      className = 'abs-container d-flex align-items-center h-100';
    }

    return (
      <CloudPanel
        id={'not-found'}
        hideJSILogo={true}
        screenHeight={this.props.pageHeight}
      >
        <div className={className}>
          <Container>
            <Row>
              <Col xl={10} lg={10} md={12} className={'mx-auto'}>
                <div
                  className={'background-white p-5 text-center'}
                  style={
                    isMobile
                      ? { marginBottom: '100px' }
                      : { maxHeight: '500px', overflowY: 'auto' }
                  }
                >
                  <h1 className={'text-center'}>Page Not Found!</h1>
                  <Link to={'/'} className={'btn btn-primary mt-4'}>
                    Back to home page
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </CloudPanel>
    );
  }
}
export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.jsx